import { render, staticRenderFns } from "./ForgotForm.vue?vue&type=template&id=6d48fb33&scoped=true&"
import script from "./ForgotForm.vue?vue&type=script&lang=ts&"
export * from "./ForgotForm.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotForm.vue?vue&type=style&index=0&id=6d48fb33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d48fb33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d48fb33')) {
      api.createRecord('6d48fb33', component.options)
    } else {
      api.reload('6d48fb33', component.options)
    }
    module.hot.accept("./ForgotForm.vue?vue&type=template&id=6d48fb33&scoped=true&", function () {
      api.rerender('6d48fb33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/components/ForgotForm.vue"
export default component.exports